import { createAsyncThunk } from '@reduxjs/toolkit';

import { UpdateAlertSettingsUserProps } from 'entities/AlertSettingsUser';

import {
  getAlertSettingsUserListService,
  updateAlertSettingsUserService,
} from 'services/alert_settings_user.service';

export const getAlertSettingsUserList = createAsyncThunk(
  'alertSettingsUser/list',
  async (_, thunkApi) => {
    try {
      const response = await getAlertSettingsUserListService();

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const updateAlertSettingsUser = createAsyncThunk(
  'alertSettingsUser/update',
  async (data: UpdateAlertSettingsUserProps, thunkApi) => {
    try {
      const response = await updateAlertSettingsUserService(data);

      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
